
import { useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { KarmaActivity } from "../types/karma-types";

export const useKarmaActivityLog = () => {
  const [activities, setActivities] = useState<KarmaActivity[]>([]);
  const [loadingActivities, setLoadingActivities] = useState(true);
  const { user } = useAuth();

  const fetchKarmaActivities = useCallback(async () => {
    if (!user) {
      setActivities([]);
      setLoadingActivities(false);
      return [];
    }
    setLoadingActivities(true);
    try {
      const { data: activitiesData, error } = await supabase
        .from('karma_activities')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false })
        .limit(10);

      if (error) {
        console.error("Error fetching karma activities:", error.message);
        setActivities([]);
        return [];
      }
      
      if (activitiesData) {
        setActivities(activitiesData as KarmaActivity[]);
        return activitiesData as KarmaActivity[];
      }
      return [];
    } catch (error: any) {
      console.error("Failed to fetch karma activities:", error.message);
      setActivities([]);
      return [];
    } finally {
      setLoadingActivities(false);
    }
  }, [user]);

  return {
    activities,
    setActivities,
    loadingActivities,
    fetchKarmaActivities,
  };
};
